import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { StaffBenefitRequestsService } from "lib-klab-sdks";
import { StaffBenefitRequestsPort } from "../../../app/ports/employment/staff-benefit-requests.port";
import {
  BenefitRequestStatus,
  EmployeeBenefitDecision,
  EmployeeBenefitRequest,
  EmployeeBenefitRequestCreate,
} from "../../../domain/models/employment/benefit.model";
import { mapEmployeeBenefitRequest } from "../../mappers/employment/benefit.mapper";

@Injectable({ providedIn: "root" })
export class StaffBenefitRequestsPortAdapter implements StaffBenefitRequestsPort {
  constructor(private readonly api: StaffBenefitRequestsService) {}

  list(filters?: {
    companyId?: number;
    employeeId?: number;
    benefitId?: number;
    status?: BenefitRequestStatus;
  }): Observable<EmployeeBenefitRequest[]> {
    return this.api
      .list(filters)
      .pipe(map((response) => response.content.map(mapEmployeeBenefitRequest)));
  }

  getById(benefitRequestId: number): Observable<EmployeeBenefitRequest> {
    return this.api
      .getById(benefitRequestId)
      .pipe(map(mapEmployeeBenefitRequest));
  }

  create(
    request: EmployeeBenefitRequestCreate,
  ): Observable<EmployeeBenefitRequest> {
    return this.api.create(request).pipe(map(mapEmployeeBenefitRequest));
  }

  decide(
    benefitRequestId: number,
    request: EmployeeBenefitDecision,
  ): Observable<EmployeeBenefitRequest> {
    return this.api
      .decide(benefitRequestId, request)
      .pipe(map(mapEmployeeBenefitRequest));
  }

  cancel(benefitRequestId: number): Observable<EmployeeBenefitRequest> {
    return this.api
      .cancel(benefitRequestId)
      .pipe(map(mapEmployeeBenefitRequest));
  }
}
